/**
 * ─────────────────────────────────────────────────────────────────────────────
 *  ENREGISTREMENT DU SERVICE WORKER PWA (/sw.js) au démarrage de l'application
 * ─────────────────────────────────────────────────────────────────────────────
 *  Indispensable pour :
 *   - la réception des notifications push natives (le SW doit être ACTIF)
 *   - l'installabilité de la PWA (manifest + SW actif)
 *   - le cache app-shell offline
 *  Fire-and-forget : un échec n'empêche jamais l'application de fonctionner.
 * ─────────────────────────────────────────────────────────────────────────────
 */
export const registerServiceWorker = () => {
  if (typeof window === "undefined" || !("serviceWorker" in navigator)) return;

  // Après le `load` pour ne pas concurrencer le bootstrap React
  window.addEventListener("load", () => {
    navigator.serviceWorker
      .register("/sw.js", { scope: "/" })
      .then((registration) => {
        // Un nouveau SW est en attente → recharge à la prochaine navigation
        registration.addEventListener("updatefound", () => {
          const installing = registration.installing;
          installing?.addEventListener("statechange", () => {
            if (installing.state === "installed" && navigator.serviceWorker.controller) {
              installing.postMessage?.({ type: "SKIP_WAITING" });
            }
          });
        });
      })
      .catch((error) => {
        console.warn("[PWA] Service Worker non enregistré :", error);
      });
  });
};
